import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import jwt_decode from 'jwt-decode'

import logo from '../img/logo-white.png'
import loadingImg from '../loading.svg'

import '../login.css'

// Apre questo path quando un utente clicca un link QR (es. da WhatsApp).
// Consuma automaticamente il token e, se valido, salva il JWT e va a /order.
// Se il token è già stato usato o scaduto, mostra un errore chiaro.
function QrLogin({ setUser }) {
  const location = useLocation()
  const history = useHistory()
  const [status, setStatus] = useState('loading') // loading | error
  const [errorMsg, setErrorMsg] = useState('')
  // Il QR è monouso lato server. Una doppia esecuzione del fetch (es.
  // perché useEffect ri-runna se cambiano le ref di props/history)
  // farebbe fallire la seconda chiamata con 401 dopo che la prima ha già
  // bruciato il token. Guard a ref-level: il fetch parte una volta sola
  // per ogni token presente in URL.
  const consumedTokenRef = useRef(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')
    if (!token) {
      setStatus('error')
      setErrorMsg('Link QR non valido: manca il token.')
      return
    }
    if (consumedTokenRef.current === token) return
    consumedTokenRef.current = token
    let cancelled = false
    ;(async () => {
      try {
        const r = await fetch('/api/auth/qr-login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        })
        if (cancelled) return
        if (!r.ok) {
          if (r.status === 401) {
            setErrorMsg(
              'Questo QR non è più valido: è già stato usato o è scaduto. Chiedi all\'admin di generarne uno nuovo.',
            )
          } else if (r.status === 429) {
            setErrorMsg('Troppi tentativi. Riprova tra qualche istante.')
          } else {
            setErrorMsg('Accesso fallito. Riprova più tardi.')
          }
          setStatus('error')
          return
        }
        const data = await r.json()
        if (data && data.token) {
          localStorage.setItem('cut-catering-token', data.token)
          setUser(jwt_decode(data.token))
          history.replace('/order')
        } else {
          setErrorMsg('Risposta inattesa dal server.')
          setStatus('error')
        }
      } catch (e) {
        if (cancelled) return
        setErrorMsg('Impossibile contattare il server.')
        setStatus('error')
      }
    })()
    return () => {
      cancelled = true
    }
  }, [location.search, history, setUser])

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-title-box">
          <img src={logo} className="logo-small" alt="logo app" />
        </div>
        <div className="login-input-box">
          {status === 'loading' ? (
            <>
              <h1 className="login-title">Accesso in corso…</h1>
              <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 6px' }}>
                <img src={loadingImg} alt="loading..." />
              </div>
              <p style={{ textAlign: 'center', color: '#ddd', fontSize: 13 }}>
                Stiamo verificando il QR.
              </p>
            </>
          ) : (
            <>
              <h1 className="login-title">QR non valido</h1>
              <p style={{ color: '#ffb3b3', textAlign: 'center', lineHeight: 1.5 }}>
                {errorMsg}
              </p>
              <div className="login-submit-row">
                <button
                  type="button"
                  className="login-button"
                  onClick={() => history.replace('/login')}
                >
                  Vai al login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default QrLogin
